import React from 'react';
import useResponsive from '../../../hooks/useResponsive';
import useScrollDirection from '../../../hooks/useScrollDirection';
import Icon from '../Icon/Icon';
import Link from '../Link/Link';
import { motion, AnimatePresence } from '../framer-motion-custom';
import * as styles from './BackLink.module.scss';
import useScrollPosition from '../../../hooks/useScrollPosition';

const BackLink = ({ label, path }) => {
  const scrollPos = useScrollPosition();
  const { isXLarge } = useResponsive();
  const scrollDir = useScrollDirection({ initialDirection: 'down', thresholdPixels: 100 });
  const isVisible = scrollPos > 125;

  return (
    <AnimatePresence initial={false}>
      <motion.div
        className={styles.container}
        animate={{ x: isVisible && path && scrollDir === 'up' ? '0%' : '-200%' }}
        aria-label={!isXLarge && `More ${label}`}
      >
        <Link className={styles.link} to={path}>
          <Icon name="arrow-left" /> {isXLarge && `More ${label}`}
        </Link>
      </motion.div>
    </AnimatePresence>
  );
};

export default BackLink;
